import springApi from '../../services/springApi'

export const getSurveys = params => (
	new Promise((resolve, reject) => {
		springApi()
			.get('/surveys', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storePublicSurvey = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/public/surveys', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)